import { render, staticRenderFns } from "./pen.vue?vue&type=template&id=d94d4aa4"
import script from "./pen.vue?vue&type=script&lang=js"
export * from "./pen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports